import { RoutingAction, RoutingActionTypes } from '../actions/routing.actions';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { RecentRoute } from '../../models/RecentRoutes';

export const ROUTING_FEATURE_KEY = 'routing';

export interface RoutingState extends EntityState<RecentRoute> {
  recentRoutes: RecentRoute[];
  loaded: boolean;
}

export interface RoutingPartialState {
  readonly [ROUTING_FEATURE_KEY]: RoutingState;
}

export const initialState: RoutingState = {
  ids: [],
  entities: {},
  recentRoutes: [],
  loaded: false,
};
const adapter: EntityAdapter<RecentRoute> = createEntityAdapter<RecentRoute>();

export function routingReducer(
  state: RoutingState = initialState,
  action: RoutingAction,
): RoutingState {
  switch (action.type) {
    case RoutingActionTypes.FetchRecentRoutesSuccess: {
      return adapter.setAll(action.payload, {
        ...state,
        recentRoutes: state.loaded ? state.recentRoutes : action.payload,
        loaded: !state.loaded,
      });
    }

    case RoutingActionTypes.UpdateRecentRoutesSuccess: {
      return adapter.setAll(action.payload, {
        ...state,
        recentRoutes: action.payload,
      });
    }
  }
  return state;
}

const { selectEntities } = adapter.getSelectors();

export const getAllRoutes = selectEntities;
